import { motion } from "framer-motion";

function LoadingScreen(props) {
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center text-center text-[12px]">
      <motion.div
        className="my-3"
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          ease: "linear",
          repeat: Infinity, // 무한 반복
        }}
        style={{
          width: "30px",
          height: "30px",
          border: "6px solid black", // 회색
          borderTop: "6px solid white", // 파란색
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></motion.div>
      <div className="mt-3">{props.txt}</div>
      <div>{props.subtxt}</div>
    </div>
  );
}

export default LoadingScreen;
